<template>
  <div id="overview_tab"
       class="main-tab main-tab-o">
    <div class="dv-content-ov">
      <img src="../assets/images/icon_ov_bg.png"
           class="img-ov-bg">
      <div class="dv-content-s-ov">
        <div class="tv-title">以人为本 生命至上</div>
        <div class="dv-content-item-ov">
          <div class="dv-left-news">
            <div class="tv-ks-title-news">医院概况</div>
            <div class="ks-lists-news">
              <el-tree :data="newslist"
                       :props="defaultProps"
                       @node-click="handleNodeClick"
                       :default-checked-keys="[1]"
                       node-key="id"
                       :current-node-key="current"
                       highlight-current></el-tree>
            </div>
          </div>
          <div class="dv-rights-ov">
            <div class="tv-ks-names-news">{{ current == 1 ? '医院简介' : '领导团队' }}</div>
            <div class="dv-yyjj"
                 v-if="current == 1"
                 v-html="hospitaldetails.content">

            </div>
            <div class="dv-ldtd"
                 v-if="current == 2">
              <div v-for="(item,index) in leaderlists"
                   v-bind:key="index">
                <div class="dv-ldtd-1"
                     v-if="index % 2 == 0">
                  <el-image :src="item.fileUrl"
                            class="img-head"
                            fit="cover"></el-image>
                  <div class="dv-right-s">
                    <div class="tv-ov-name">{{ item.name }}</div>
                    <div class="ov-line"></div>
                    <div class="tv-ov-1">职务：{{ item.duties }}</div>
                    <div class="tv-ov-2">职责：{{ item.duty }}</div>
                    <div class="tv-ov-2"
                         style="margin-bottom: 10px;">介绍：{{ item.introduce }}</div>
                  </div>

                </div>
                <div class="dv-ldtd-1"
                     v-if="index % 2 == 1">

                  <div class="dv-right-s">
                    <div class="tv-ov-name">{{ item.name }}</div>
                    <div class="ov-line"></div>
                    <div class="tv-ov-1">职务：{{ item.duties }}</div>
                    <div class="tv-ov-2">职责：{{ item.duty }}</div>
                    <div class="tv-ov-2"
                         style="margin-bottom: 10px;">介绍：{{ item.introduce }}</div>
                  </div>
                  <el-image :src="item.fileUrl"
                            class="img-head"
                            fit="cover"></el-image>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import api from '../api/api'
export default {
  data () {
    return {
      current: 1,
      newslist: [{
        ksname: '医院简介',
        id: 1,
      },
      {
        ksname: '领导团队',
        id: 2,
      }
      ],
      defaultProps: {
        label: 'ksname',
        children: 'kschine',
      },
      hospitaldetails: '',
      leaderlists: [],//领导团队
    }
  },
  created () {
    if (this.$route.query.type == 'team') {
      this.current = 2
    }
    this.hospitaldetail()
    this.leaderlist()
  },
  methods: {
    handleNodeClick (e) {
      console.log(e)
      this.current = e.id

    },
    //医院简介
    hospitaldetail () {
      let parm = {
        FKEY: api.getFKEY(),
      }
      api.hospitaldetail(parm).then((res) => {
        this.hospitaldetails = res.data

      })
    },
    //领导团队
    leaderlist () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: 1,
        showCount: 100,

      }
      api.leaderlist(parm).then((res) => {
        this.leaderlists = res.data.list

      })
    },
  }
}
</script>

<style>
.dv-content-ov {
  width: 100%;
  height: fit-content;
  display: flex;
  position: relative;
  flex-direction: column;
}
.img-ov-bg {
  position: absolute;
  /* top: 40px; */
  left: 0;
  width: 100%;
}
.dv-content-s-ov {
  width: calc(100% - 600px);
  height: fit-content;
  margin-left: 300px;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
}
.dv-content-item-ov {
  width: 100%;
  /* margin-bottom: 200px; */
  height: fit-content;
  margin-top: 50px;
  display: flex;
  flex-direction: row;
}
.dv-rights-ov {
  display: flex;
  width: calc(100% - 300px);
  /* background: white; */
  flex-direction: column;
  background: white;
  margin-bottom: 30px;
}
.dv-yyjj {
  width: calc(100% - 40px);
  margin-left: 20px;
  min-height: 800px;
  font-size: 20px;
  margin-bottom: 20px;
  margin-top: 20px;
  line-height: 40px;
}
.dv-ldtd {
  width: calc(100% - 40px);
  margin-left: 20px;
  margin-top: 30px;

  display: flex;
  flex-direction: column;
}
.dv-ldtd-1 {
  width: 100%;
  height: fit-content;
  background: #eff2fa;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
}
.img-head {
  width: 200px;
  margin: 8px;
  height: 224px;
}
.dv-right-s {
  width: calc(100% - 230px);
  margin-left: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.tv-ov-name {
  font-size: 28px;
  /* font-family: PingFang SC, PingFang SC-Semibold; */
  font-weight: 500;
  text-align: left;
  color: #bb9654;
  margin-top: 30px;
}
.ov-line {
  width: 100%;
  height: 3px;
  margin-top: 20px;
  background: #bb9654;
}
.tv-ov-1 {
  font-size: 18px;
  /* font-family: PingFang SC, PingFang SC-Semibold; */
  font-weight: 400;
  text-align: left;
  margin-top: 10px;
  color: #333333;
}
.tv-ov-2 {
  width: calc(100% - 20px);
  font-size: 18px;
  /* font-family: PingFang SC, PingFang SC-Semibold; */
  font-weight: 400;
  line-height: 30px;
  text-align: left;
  margin-top: 10px;
  color: #666666;
}
</style>